import { SvgIcon } from '@mui/material';
import RedditLogo from './reddit-logo.svg?react';

export function RedditIcon() {
  return (
    <SvgIcon>
      <RedditLogo />
    </SvgIcon>
  );
}
